import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Chip, 
  TextField,
  Card,
  CardContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const initialTerms = [
  "darn",
  "stupid",
  "idiot",
  "shut up",
  "hate",
  "dumb",
  "loser",
  "annoying"
];

const ZeroToleranceInput = ({ onUpdate }) => {
  const [terms, setTerms] = useState(initialTerms);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    onUpdate(initialTerms);
  }, [onUpdate]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim()) {
      const newTerms = [...terms, inputValue.trim()];
      setTerms(newTerms);
      onUpdate(newTerms);
      setInputValue('');
    }
  };

  const handleDelete = (termToDelete) => {
    const newTerms = terms.filter((term) => term !== termToDelete);
    setTerms(newTerms);
    onUpdate(newTerms);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        maxWidth: 800,
        mx: 'auto',
        bgcolor: 'background.paper',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        boxShadow: 'none',
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: terms.length > 0 ? 2 : 0,
          }}
        >
          {terms.map((term) => (
            <Chip
              key={term}
              label={term}
              onDelete={() => handleDelete(term)}
              deleteIcon={<CloseIcon sx={{ fontSize: '1rem' }} />}
              sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 2,
                '&:hover': { bgcolor: '#eeeeee' },
                '& .MuiChip-deleteIcon': {
                  color: '#9e9e9e',
                  '&:hover': {
                    color: '#757575',
                  },
                },
              }}
            />
          ))}
        </Box>
        <TextField
          fullWidth
          placeholder="Enter your zero tolerance terms"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              bgcolor: '#fff',
              '& fieldset': {
                borderColor: '#e0e0e0',
                borderWidth: '1.5px',
              },
              '&:hover fieldset': {
                borderColor: '#bdbdbd',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
                borderWidth: '1.5px',
              },
            },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default ZeroToleranceInput; 